<template>
  <flex-layout role="region">
    <vue-loading :active="isLoading" :is-full-page="true" />

    <BlockContainer header-variant="secondary" :title="$t(shopStore.getShopName)">
      <ShopDetails :shop-id="shopId" />
    </BlockContainer>

    <BlockContainer :title="$t('orderDetails.title')">
      <OrderDetails
        :guid="guid"
        :shop-id="wondShopId"
        :show-cancel-button="false"
        :show-status-label="false"
        :show-payments-table="false"
      />
    </BlockContainer>
  </flex-layout>
</template>

<script>
import VueLoading from "vue-loading-overlay";
import {useAppStore} from "@/stores/app";
import {useShopStore} from "@/stores/shop";
import OrderDetails from "@/components/sub-components/Order/OrderDetails.vue";
import ShopDetails from "@/components/page-components/Shop/ShopDetails.vue";
import BlockContainer from "@/components/layout/BlockContainer.vue";
import FlexLayout from "@/components/layout-components/Main/FlexLayout.vue";

export default {
  components: {
    FlexLayout,
    BlockContainer,
    ShopDetails,
    OrderDetails,
    VueLoading,
  },
  setup() {
    const appStore = useAppStore();
    const shopStore = useShopStore();

    return { appStore, shopStore };
  },
  data() {
    return {
      isLoading: false,
      guid: this.appStore.currentOrderGuid,
      shopId: this.shopStore.id,
      wondShopId: this.shopStore.wondId,
    };
  },
};
</script>

<style>
.header-title h2 {
  font-size: 24px;
  color: var(--primary-color);
}

/* Customer Info List Style */
.column-right ul {
  list-style-type: none;
  padding: 0;
}

.column-right li {
  margin-bottom: 10px;
}

/* Button Style */
.column-right button {
  margin-top: 20px;
}
</style>
